// IE Hub - UI Constants
// Shared UI strings and configuration constants

export const UI_MESSAGES = {
  CHARACTER_LIMIT_REACHED: "The character limit has been reached.",
  APOSTROPHE_NOT_ALLOWED: "Single inverted comma (') is not allowed",
};
